// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Image } from 'react-bootstrap';
// import Swal from 'sweetalert2';

// const EditProfileModal = ({ setShow, show, user, handleFileUpload }) => {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     bio: "",
//     tagline: "",
//     profile_pic: "",
//     social_links: []
//   });

//   const [profilePreview, setProfilePreview] = useState("");
//   const token = localStorage.getItem("jwttoken");

//   // Fetch user data when the modal is opened
//   useEffect(() => {
//     if (show) {
//       axios
//         .get("https://kaasbackend.vetrinahealthcare.com/lms/user/", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           const userData = response.data;
//           setFormData({
//             first_name: userData.first_name || "",
//             last_name: userData.last_name || "",
//             bio: userData.bio || "",
//             tagline: userData.tagline || "",
//             profile_pic: userData.profile_pic || "",
//             social_links: userData.social_links || []
//           });
//           setProfilePreview(userData.profile_pic || "");
//         })
//         .catch((reason) => {
//           console.error("Failed to fetch user data:", reason);
//           Swal.fire({
//             icon: "error",
//             title: "Failed to Load Data",
//             text: "There was an error loading your profile data.",
//             confirmButtonText: "OK",
//           });
//         });
//     }
//   }, [show]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleProfilePicChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfilePreview(reader.result);
//         setFormData({ ...formData, profile_pic: reader.result });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = (e) => {
//     axios
//       .patch("https://kaasbackend.vetrinahealthcare.com/lms/user/", e, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         console.log(response.data);
//         Swal.fire({
//           icon: "success",
//           title: "Profile Updated",
//           text: "Your profile details have been successfully updated!",
//           confirmButtonText: "OK",
//         });
//         setShow(false);
//       })
//       .catch((reason) => {
//         console.error("Failed to update profile:", reason);
//         Swal.fire({
//           icon: "error",
//           title: "Failed to Update Profile",
//           text: "There was an error updating your profile. Please try again.",
//           confirmButtonText: "OK",
//         });
//       });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     let newData = {};

//     Object.keys(formData).forEach((k) => {
//       if (formData[k]) {
//         newData[k] = formData[k];
//       }
//     });

//     console.log(newData);

//     handleSave(newData);
//   };

//   const handleClose = () => setShow(false);

//   return (
//     <>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         backdrop="static"
//         keyboard={false}
//         style={{ opacity: 1 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             backgroundColor: "#f8f9fa",
//             borderBottom: "none",
//             paddingBottom: "0",
//           }}
//         >
//           <Modal.Title
//             style={{
//               color: "#B8529E",
//               textAlign: "center",
//               width: "100%",
//               fontWeight: "bold",
//             }}
//           >
//             Edit Profile
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "20px 30px" }}>
//           <Form onSubmit={handleSubmit}>
//             <Form.Group controlId="formFirstName">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 First Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="first_name"
//                 value={formData.first_name}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formLastName" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Last Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="last_name"
//                 value={formData.last_name}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formTagline" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Tagline
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="tagline"
//                 value={formData.tagline}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formBio" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Bio
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 name="bio"
//                 rows={3}
//                 value={formData.bio}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formProfilePic" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Profile Picture
//               </Form.Label>
//               <Button
//                 variant="secondary"
//                 onClick={() => document.getElementById("profilePicInput").click()}
//                 style={{
//                   display: "block",
//                   margin: "10px 0",
//                   backgroundColor: "#B8529E",
//                   border: "none",
//                   width: "100%",
//                   transition: "background-color 0.3s ease, transform 0.3s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = "#9b4283";
//                   e.target.style.transform = "scale(1.05)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = "#B8529E";
//                   e.target.style.transform = "scale(1)";
//                 }}
//               >
//                 Upload
//               </Button>
//               <input
//                 type="file"
//                 id="profilePicInput"
//                 style={{ display: "none" }}
//                 accept="image/*"
//                 onChange={handleProfilePicChange}
//               />
//               {profilePreview && (
//                 <div style={{ textAlign: "center", marginTop: "15px" }}>
//                   <Image
//                     src={profilePreview}
//                     roundedCircle
//                     style={{ width: "150px", height: "150px" }}
//                   />
//                 </div>
//               )}
//             </Form.Group>

//             <Button
//               variant="primary"
//               type="submit"
//               style={{
//                 backgroundColor: "#B8529E",
//                 border: "none",
//                 borderRadius: "10px",
//                 width: "100%",
//                 marginTop: "20px",
//                 padding: "10px",
//                 transition: "background-color 0.3s ease, transform 0.3s ease",
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = "#9b4283";
//                 e.target.style.transform = "scale(1.05)";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "#B8529E";
//                 e.target.style.transform = "scale(1)";
//               }}
//             >
//               Save Changes
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default EditProfileModal;

import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Image } from 'react-bootstrap'
import Swal from 'sweetalert2'

const EditProfileModal = ({ setShow, show, user, handleFileUpload }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    //bio: "",
    //tagline: "",
    profile_pic: '',
    cover_photo: '',
    nickname: '',
    social_links: [],
  })

  const [profilePreview, setProfilePreview] = useState('')
  const [coverPhotoPreview, setCoverPhotoPreview] = useState('')
  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    if (show) {
      axios
        .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const userData = response.data
          setFormData({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            //bio: userData.bio || "",
            //tagline: userData.tagline || "",
            profile_pic: userData.profile_pic || '',
            cover_photo: userData.cover_photo || '',
            nickname: userData.nickname || '',
            social_links: userData.social_links || [],
          })
          setProfilePreview(userData.profile_pic || '')
          setCoverPhotoPreview(userData.cover_photo || '')
        })
        .catch((reason) => {
          console.error('Failed to fetch user data:', reason)
          Swal.fire({
            icon: 'error',
            title: 'Failed to Load Data',
            text: 'There was an error loading your profile data.',
            confirmButtonText: 'OK',
          })
        })
    }
  }, [show])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setProfilePreview(reader.result)
        setFormData({ ...formData, profile_pic: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCoverPhotoChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setCoverPhotoPreview(reader.result)
        setFormData({ ...formData, cover_photo: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSave = (e) => {
    axios
      .patch('https://kaasbackend.vetrinahealthcare.com/lms/user/', e, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data)
        Swal.fire({
          icon: 'success',
          title: 'Profile Updated',
          text: 'Your profile details have been successfully updated!',
          confirmButtonText: 'OK',
        })
        setShow(false)
      })
      .catch((reason) => {
        console.error('Failed to update profile:', reason)
        Swal.fire({
          icon: 'error',
          title: 'Failed to Update Profile',
          text: 'There was an error updating your profile. Please try again.',
          confirmButtonText: 'OK',
        })
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let newData = {}

    Object.keys(formData).forEach((k) => {
      if (formData[k]) {
        newData[k] = formData[k]
      }
    })

    console.log(newData)

    handleSave(newData)
  }

  const handleClose = () => setShow(false)

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop='static'
        keyboard={false}
        style={{ opacity: 1 }}
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: '#f8f9fa',
            borderBottom: 'none',
            paddingBottom: '0',
          }}
        >
          <Modal.Title
            style={{
              color: '#B8529E',
              textAlign: 'center',
              width: '100%',
              fontWeight: 'bold',
            }}
          >
            Edit Profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px 30px' }}>
          <Form onSubmit={handleSubmit}>
            {/* First Name */}
            <Form.Group controlId='formFirstName'>
              <Form.Label style={{ fontWeight: 'bold', color: '#B8529E' }}>
                First Name
              </Form.Label>
              <Form.Control
                type='text'
                name='first_name'
                value={formData.first_name}
                onChange={handleChange}
                style={{
                  borderRadius: '10px',
                  borderColor: '#B8529E',
                }}
              />
            </Form.Group>

            {/* Last Name */}
            <Form.Group controlId='formLastName' className='mt-3'>
              <Form.Label style={{ fontWeight: 'bold', color: '#B8529E' }}>
                Last Name
              </Form.Label>
              <Form.Control
                type='text'
                name='last_name'
                value={formData.last_name}
                onChange={handleChange}
                style={{
                  borderRadius: '10px',
                  borderColor: '#B8529E',
                }}
              />
            </Form.Group>

            {/* Nickname */}
            <Form.Group controlId='formNickname' className='mt-3'>
              <Form.Label style={{ fontWeight: 'bold', color: '#B8529E' }}>
                Nickname
              </Form.Label>
              <Form.Control
                type='text'
                name='nickname'
                value={formData.nickname}
                onChange={handleChange}
                style={{
                  borderRadius: '10px',
                  borderColor: '#B8529E',
                }}
              />
            </Form.Group>

            {/* Profile Picture */}
            <Form.Group controlId='formProfilePic' className='mt-3'>
              <Form.Label style={{ fontWeight: 'bold', color: '#B8529E' }}>
                Profile Picture
              </Form.Label>
              <Button
                variant='secondary'
                onClick={() =>
                  document.getElementById('profilePicInput').click()
                }
                style={{
                  display: 'block',
                  margin: '10px 0',
                  backgroundColor: '#B8529E',
                  border: 'none',
                  width: '100%',
                  transition: 'background-color 0.3s ease, transform 0.3s ease',
                }}
              >
                Upload
              </Button>
              <input
                type='file'
                id='profilePicInput'
                style={{ display: 'none' }}
                accept='image/*'
                onChange={handleProfilePicChange}
              />
              {profilePreview && (
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Image
                    src={profilePreview}
                    roundedCircle
                    style={{ width: '150px', height: '150px' }}
                  />
                </div>
              )}
            </Form.Group>

            {/* Cover Photo */}
            <Form.Group controlId='formCoverPhoto' className='mt-3'>
              <Form.Label style={{ fontWeight: 'bold', color: '#B8529E' }}>
                Cover Photo
              </Form.Label>
              <Button
                variant='secondary'
                onClick={() =>
                  document.getElementById('coverPhotoInput').click()
                }
                style={{
                  display: 'block',
                  margin: '10px 0',
                  backgroundColor: '#B8529E',
                  border: 'none',
                  width: '100%',
                  transition: 'background-color 0.3s ease, transform 0.3s ease',
                }}
              >
                Upload
              </Button>
              <input
                type='file'
                id='coverPhotoInput'
                style={{ display: 'none' }}
                accept='image/*'
                onChange={handleCoverPhotoChange}
              />
              {coverPhotoPreview && (
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Image
                    src={coverPhotoPreview}
                    rounded
                    style={{ width: '100%', maxHeight: '200px' }}
                  />
                </div>
              )}
            </Form.Group>

            <Button
              variant='primary'
              type='submit'
              style={{
                backgroundColor: '#B8529E',
                border: 'none',
                borderRadius: '10px',
                width: '100%',
                marginTop: '20px',
                padding: '10px',
                transition: 'background-color 0.3s ease, transform 0.3s ease',
              }}
            >
              Save Changes
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditProfileModal
